import {AssociationOne} from '../../../../projects/entity-manager/src/lib/decorator/associations/association-one';
import {Estimate, Product, ProductType, Unit, Vat} from './entities';
import {Route} from '../../../../projects/entity-manager/src/lib/decorator/route';
import {
    CrossDependency
} from '../../../../projects/entity-manager/src/lib/decorator/cross-dependency';
import {Meta} from '../../../../projects/entity-manager/src/lib/service/meta/meta';

import {Repository} from '../../../../projects/entity-manager/src/lib/decorator/repository';
import {EstimateItemRepository} from '../repositories/estimate-item.repository';
import {DeletePropertyPayloadModifier} from '../../../../projects/entity-manager/src/lib/decorator/payload-modifiers/types/delete-property-payload-modifier';
import {PropertyPayloadModifier} from '../../../../projects/entity-manager/src/lib/decorator/payload-modifiers/property-payload-modifier';

@Route('estimate_items')
@CrossDependency(() => {
    return {
        master: {
            mapping: Meta.META_ASSOCIATIONS,
            entity: Estimate
        },
        product: {
            mapping: Meta.META_ASSOCIATIONS,
            entity: Product
        },
        productType: {
            mapping: Meta.META_ASSOCIATIONS,
            entity: ProductType
        },
        vat: {
            mapping: Meta.META_ASSOCIATIONS,
            entity: Vat
        },
        unit: {
            mapping: Meta.META_ASSOCIATIONS,
            entity: Unit
        }
    };
})
@Repository(EstimateItemRepository)
export class EstimateItem {

    protected id: string;
    protected name: string;

    @AssociationOne(Estimate)
    protected master;

    @AssociationOne(Product)
    protected product;

    @AssociationOne(ProductType)
    protected productType;

    @AssociationOne(Vat)
    protected vat;

    @AssociationOne(Unit)
    protected unit;

    protected rebate: number;

    protected quantity;

    protected price;
    protected priceWithRebate: number;
    protected priceWithVat: number;

    @PropertyPayloadModifier(DeletePropertyPayloadModifier)
    protected totalPrice;
    protected productDescription;
    protected sortPosition: number;

    public setId(id: string) {
        this.id = id;
        return this;
    }

    public getId(): string {
        return this.id;
    }

    public setName(name: string): EstimateItem {
        this.name = name;
        return this;
    }

    public getName(): string {
        return this.name;
    }

    public setMaster(master: Estimate): EstimateItem {
        this.master = master;
        return this;
    }

    public getMaster(): Estimate | undefined {
        return this.master;
    }

    public setProduct(product: Product): EstimateItem {
        this.product = product;
        return this;
    }

    public getProduct(): Product | undefined {
        return this.product;
    }

    public setProductType(productType: ProductType): EstimateItem {
        this.productType = productType;
        return this;
    }

    public getProductType(): ProductType | undefined {
        return this.productType;
    }

    public setVat(vat: Vat): EstimateItem {
        this.vat = vat;
        return this;
    }

    public getVat(): Vat | undefined {
        return this.vat;
    }

    public getUnit(): Unit | undefined {
        return this.unit;
    }

    public setUnit(unit: Unit): EstimateItem {
        this.unit = unit;
        return this;
    }

    public setRebate(rebate: number): EstimateItem {
        this.rebate = rebate;
        return this;
    }

    public getRebate(): number | undefined {
        return this.rebate;
    }

    public setQuantity(quantity: number): EstimateItem {
        this.quantity = quantity;
        return this;
    }

    public getQuantity(): number | undefined {
        return this.quantity;
    }

    public setPrice(price: number): EstimateItem {
        this.price = price;
        return this;
    }

    public getPrice(): number | undefined {
        return this.price;
    }

    public getTotalPrice(): number | undefined {
        return this.totalPrice;
    }

    public setTotalPrice(totalPrice: number): EstimateItem {
        this.totalPrice = totalPrice;
        return this;
    }

    public setProductDescription(productDescription: string): EstimateItem {
        this.productDescription = productDescription;
        return this;
    }

    public getProductDescription(): string {
        return this.productDescription;
    }

    public getSortPosition(): number {
        return this.sortPosition;
    }

    public setSortPosition(sortPosition: number): EstimateItem {
        this.sortPosition = sortPosition;
        return this;
    }

    public setPriceWithRebate(priceWithRebate: number): EstimateItem {
        this.priceWithRebate = priceWithRebate;
        return this;
    }

    public getPriceWithRebate(): number | undefined {
        return this.priceWithRebate;
    }

    public setPriceWithVat(priceWithVat: number): EstimateItem {
        this.priceWithVat = priceWithVat;
        return this;
    }

    public getPriceWithVat(): number | undefined {
        return this.priceWithVat;
    }
}
